Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "SingleWidgetTile2546503964",
  {"root":"SingleWidgetTile2546503964--root","left":"SingleWidgetTile2546503964--left","right":"SingleWidgetTile2546503964--right","horizontal":"SingleWidgetTile2546503964--horizontal","dualView":"SingleWidgetTile2546503964--dualView","tilePart":"SingleWidgetTile2546503964--tilePart","vertical":"SingleWidgetTile2546503964--vertical","round":"SingleWidgetTile2546503964--round","none":"SingleWidgetTile2546503964--none","reversed":"SingleWidgetTile2546503964--reversed","margin-amount":"18%"},
  "",
  9,
  "SingleWidgetTile2546503964"
);

